import { z } from "zod/v4";
import { storeLink } from "@/features/shares/store-link";
// IDs are extensible: new marketplace choices must not break mobile-store readers.
export const appLinkSchema = z.strictObject({ id: z.string().min(1), url: z.string(), platform: z.string().optional() }).superRefine((link, ctx) => {
  if (link.id === "custom" && !link.platform?.trim()) ctx.addIssue({ code: "custom", path: ["platform"], message: "Enter a name." });
});
export const appLinksSchema = z.array(appLinkSchema);
export type AppLink = z.infer<typeof appLinkSchema>;
export function canonicalAppLinkUrl(link: AppLink) {
  if (link.id === "ios" || link.id === "android") return storeLink(link.url.trim(), link.id);
  try {
    const url = new URL(link.url.trim());
    if (url.protocol !== "https:" || !url.hostname || url.username || url.password || url.port || url.href.length > 2048) return null;
    return url.href;
  } catch { return null; }
}
